import { render, staticRenderFns } from "./ViewCancel.vue?vue&type=template&id=021fea52&scoped=true&"
import script from "./ViewCancel.vue?vue&type=script&lang=js&"
export * from "./ViewCancel.vue?vue&type=script&lang=js&"
import style0 from "./ViewCancel.vue?vue&type=style&index=0&id=021fea52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021fea52",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VCard,VCardText,VCardTitle,VContainer,VProgressCircular})
